import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import ErrorBoundary from "./components/error/error-boundary";
import RootWrapper from "./components/root/RootWrapper";
import "./index.css";
import Routes from "./Routes";

// @slava - added an error handler
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <RootWrapper>
      <ErrorBoundary>
        <Toaster />
        <Routes />
      </ErrorBoundary>
    </RootWrapper>
  </BrowserRouter>
);
